import React from 'react';
import {
    Dialog,
    DialogProps,
    DialogContent,
    DialogTitleProps,
    DialogContentProps,
    DialogActionsProps,
} from '@carrotfertility/carotene-core';
import { DialogActionsBar, DialogCloseButton, DialogCloseButtonProps, DialogTitleWithImage } from './blocks';

let id_counter = 0;

export type InfoDialogProps = DialogProps & {
    /**
     * The slot for your Primary Action. Most cases should be a `Button`
     */
    primaryAction?: React.ReactNode;
    /**
     * The title text of your Dialog
     */
    title: string;
    /**
     * Component slot for your Dialog image. Please use `DialogTitleImage`.
     */
    image?: React.ReactNode | React.ReactNode[];
    /**
     * Props that allow you to update components you don't have control over.
     */
    slotProps?: {
        closeButton?: DialogCloseButtonProps;
        title?: DialogTitleProps;
        content?: DialogContentProps;
        actions?: DialogActionsProps;
    };
};

export function InfoDialog(props: InfoDialogProps) {
    const { title, primaryAction, children, slotProps, image, ...otherProps } = props;
    const [ariaId] = React.useState(id_counter++);
    const titleId = `info-dialog-${ariaId}-title`;
    return (
        <Dialog aria-labelledby={titleId} {...otherProps}>
            {!primaryAction ? (
                <DialogCloseButton
                    onClick={otherProps.onClose as React.MouseEventHandler<HTMLButtonElement>}
                    {...slotProps?.closeButton}
                />
            ) : null}
            <DialogTitleWithImage id={titleId} image={image} {...slotProps?.title}>
                {title}
            </DialogTitleWithImage>
            <DialogContent {...slotProps?.content}>{children}</DialogContent>
            {primaryAction ? <DialogActionsBar {...slotProps?.actions} primaryAction={primaryAction} /> : null}
        </Dialog>
    );
}
